import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import styles from './style.css';

class StepCardLineOpt extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleClick(item) {
        // event.emit(EVENTS[`STEP_${item}`]);
        event.emit(EVENTS[`${item.event}`], item);
    }


    render() {
        const { option } = this.props;
        
        return (
            <button
                className={`${styles.options} ${option.selected ? '' : option.disable ? styles.disabled : ""}`}
                disabled={option.disable}
                onClick={() => this.handleClick(option)}
            >
                {option.button}
            </button>

            // <button disabled={option.disable} onClick={() => this.handleClick(option)}>{option.button}</button>
        );
    }
}

export default StepCardLineOpt;
